import { render, staticRenderFns } from "./PayWall.vue?vue&type=template&id=c8657248&scoped=true"
import script from "./PayWall.vue?vue&type=script&lang=ts"
export * from "./PayWall.vue?vue&type=script&lang=ts"
import style0 from "./PayWall.vue?vue&type=style&index=0&id=c8657248&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8657248",
  null
  
)

export default component.exports